import { createContext, useContext } from 'react';
import type { AskUserToolOutputDTO } from '@shared/schemas/chat-ask-user';
import type { DocumentRevisionContextDTO } from '@shared/schemas/chat';
import type { ToolContinuationErrorState } from './chat-ask-user-flow';

export type ChatToolInteractionContextValue = {
  beginDocumentRevision: (context: DocumentRevisionContextDTO & { title: string; version: number }) => void;
  isAskUserSubmitting: boolean;
  retryAskUserContinuation: () => void;
  submitAskUserOutput: (params: {
    output: AskUserToolOutputDTO;
    toolCallId: string;
  }) => void;
  toolContinuationError: ToolContinuationErrorState | null;
};

export const ChatToolInteractionContext = createContext<ChatToolInteractionContextValue | null>(null);

export function useChatToolInteraction() {
  const context = useContext(ChatToolInteractionContext);

  if (!context) {
    throw new Error('useChatToolInteraction must be used within ChatToolInteractionProvider');
  }

  return context;
}
